import JSZip from 'jszip';
import FileSaver from 'file-saver';
import Rels from './rels';
import DocXML from './DocXML';

export default class Document {
    NumImg;
    rels;
    zip;
    filesLeft;
    docXML;

    constructor() {
        this.NumImg = 1;
        this.zip = new JSZip();
        this.rels = new Rels();
        this.docXML = new DocXML();
        this.filesLeft = 0;
    }

    addImage(imgURL, text) {
        this.filesLeft++;
        this.rels.addImage('image' + this.NumImg + '.jpg');
        let currentNum = this.NumImg;
        this.NumImg = this.NumImg + 1;
        let img = new Image();
        img.crossOrigin = 'app.dialogloop.com';
        img.onload = () => {
            let canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            this.docXML.addImage(img.width, img.height);
            this.docXML.addText(text);
            this.docXML.addPageBreak();
            let ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            let dataURL = canvas.toDataURL('image/png');
            this.zip.file('image' + currentNum + '.jpg', dataURL.replace(/^data:image\/(png|jpg);base64,/, ''), {base64: true});
            this.filesLeft--;
            if (this.filesLeft === 0) {
                this.zip.folder('_rels').file('document.xml.rels', this.rels.getString());
                this.zip.folder('_rels').file('.rels', `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
                <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
                  <Relationship Id="MyRelationship" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="document.xml"/>
                </Relationships>`);
                this.zip.file('document.xml', this.docXML.getString());
                this.zip.file('[Content_Types].xml', `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
                <Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
                  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
                  <Override PartName="/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/>
                  <Default Extension="jpg" ContentType="image/jpeg"/>
                </Types>`);
                this.zip.generateAsync({type: 'blob'})
                .then(function(content) {
                    // Force down of the Zip file
                    FileSaver.saveAs(content, 'DialogLoop-Slides.docx');
                });
            }
        }; 
        img.src = imgURL + '?timestamp=' + Date.now() + '&random=' + Math.random() * 10000000000000000000000;
    }

    downloadDocument() {
        setTimeout(this.callback, 6000);
    }

    callback() {
        if (this.filesLeft !== 0) {
            setTimeout(this.callback, 1000);
        } else {
            this.zip.folder('_rels').file('.rels', this.rels.getString());
            this.zip.generateAsync({type: 'blob'})
            .then(function(content) {
                // Force down of the Zip file
                FileSaver.saveAs(content, 'archive.zip');
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/javascript-classes/JS-DOCX/Document.js